
import axios from 'axios';
import React, { Component}  from 'react';
import { DetailProvider, DetailContext } from 'core/DetailProvider';
import { FormContext, FormProvider } from 'core/FormProvider';
import Layout from 'components/Dashboard/Layout';
import { YellowButton } from 'ui/Button';
import { ScheduleForm } from './Form';
import DeleteDialog from 'core/DeleteDialog';
import ScheduleDetailTable from './DetailTable.js';
import { Alert } from "@material-ui/lab";
import {Button} from "@material-ui/core";


export default class ScheduleDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      checkingTask: false,
      taskCheckMessage: null,
      taskCheckState: null,
    };
  }

  onLoaded = (item) => {
    document.title = `Связка ${item.id}`;
  };

  getReturnPath = () => {
    const { location } = this.props;
    if (location && location.state && location.state.from) {
      return location.state.from;
    }
    return '/schedule';
  };

  handleDelete = (item) => {
    this.props.history.push(this.getReturnPath());
  };

  handleCheckTask = (formContext) => {
    const { item } = formContext;
    this.setState({ checkingTask: true });
    axios.get(`${item.meta.url}check_creation_task/`).then(res => {
      const { state, message, schedule } = res.data;
      if (schedule) {
        formContext.setValues(schedule);
      }
      this.setState({
        checkingTask: false,
        taskCheckMessage: message,
        taskCheckState: state,
      });
    }).catch(() => {
      this.setState({
        checkingTask: false,
        taskCheckMessage: 'Не удалось проверить задачу',
        taskCheckState: 'unavailable',
      });
    });
  };

  renderCreationAlert = (item) => {
    const { taskCheckMessage, taskCheckState } = this.state;
    if (item.schedule_creation_status === 'FAILED') {
      return (
        <Alert severity="error" className={'mb-20'}>
          {taskCheckMessage || 'Формирование расписания отвалилось. Можно сохранить связку ещё раз.'}
        </Alert>
      );
    }
    if (item.schedule_creation_status === 'WORKING') {
      const severity = taskCheckState === 'unavailable' ? 'error' : 'warning';
      return (
        <Alert severity={severity} className={'mb-20'}>
          {taskCheckMessage || 'Расписание для данной связки обновляется. Может потребоваться некоторое время.'}
        </Alert>
      );
    }
    if (taskCheckMessage && taskCheckState === 'complete') {
      return (
        <Alert severity="success" className={'mb-20'}>
          {taskCheckMessage}
        </Alert>
      );
    }
    return null;
  };

  render() {
    const { match, history } = this.props;
    const { checkingTask } = this.state;
    return (
      <DetailProvider
        url={`schedule/${match.params.id}`}
      >
        <DetailContext.Consumer>
          {detailContext => {
            let { item } = detailContext;
            return (
              <FormProvider
                url={item.meta.url}
                enterSubmit={false}
                postSaveMessage={'Связка обновлена'}
                item={item}
              >
                <FormContext.Consumer>
                {formContext => {
                  const { item, loading } = formContext;
                  return (
                    <Layout>
                      <Layout.Header
                        title={'Редактирование связки'}
                        backUrl={this.getReturnPath()}
                      />

                      <Layout.ContentSimple>

                        {this.renderCreationAlert(item)}

                        <ScheduleForm />

                        <div className={'mt-30'}>
                          <YellowButton
                            onClick={(e) => formContext.handleSubmit(e)}
                            disabled={loading || item.schedule_creation_status === 'WORKING'}
                            size={'large'}
                          >
                            Обновить связку
                          </YellowButton>

                          {item.schedule_creation_status === 'WORKING' && (
                            <Button
                              onClick={() => this.handleCheckTask(formContext)}
                              disabled={loading || checkingTask}
                              size={'large'}
                              className={'ml-10'}
                              variant={'outlined'}
                            >
                              {checkingTask ? 'Проверяем…' : 'Проверить задачу'}
                            </Button>
                          )}

                          {item.can_delete && (
                            <DeleteDialog
                              item={item}
                              itemLabel={'данную связку'}
                              onDelete={() => this.handleDelete()}
                              buttonProps={{
                                className: 'ml-10'
                              }}
                            />
                          )}
                        </div>

                        <ScheduleDetailTable item={item} history={history} />

                      </Layout.ContentSimple>

                    </Layout>
                  )
                }}
                </FormContext.Consumer>
              </FormProvider>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
